import { createContext } from 'react';

import { rootStoreInstance } from 'src/stores/RootStore';
import { initializeMobX } from 'src/utils/mobxConfig';

initializeMobX();

interface StoreProviderOptions {
  children?: React.ReactNode
}

export const RootStoreContext = createContext<typeof rootStoreInstance | null>(null);

export const StoreProvider: React.FC<StoreProviderOptions> = ({ children }) => {
  return <RootStoreContext.Provider value={rootStoreInstance}>{children}</RootStoreContext.Provider>;
};
